import * as React from 'react';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import { ApiService } from '../services/api_service';
import { WFormsTableWrapper } from '../core/table/WFormsTableWrapper';

interface BenutzerverwaltungProps extends React.ClassAttributes<any> {
    containerId?: string;
    data: any;
}

interface BenutzerverwaltungState extends React.ClassAttributes<any> {
    formTid: number;
    formUpdateCount: number;
}

export class Benutzerverwaltung extends React.Component<BenutzerverwaltungProps, BenutzerverwaltungState> {
    constructor(props: any) {
        super(props);
        this.state = {
            formTid: 0,
            formUpdateCount: 0
        };
        this.callBeforeOnFormSave = this.callBeforeOnFormSave.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;

    render() {
        const regi = Array.isArray(this.props.data[IDs.ENT_REGISTRIERUNG]) && this.props.data[IDs.ENT_REGISTRIERUNG].length > 0 ? this.props.data[IDs.ENT_REGISTRIERUNG][0] : null;
        const customFormConfig = {
            mail: { readonly: this.state.formTid !== 0 },
            password: { hidden: true }
        };
        return regi ? <div>
            <WFormsTableWrapper
                refreshStamp={this.state.formUpdateCount}
                containerId={this.props.containerId}
                entity={IDs.ENT_MANDANTEN_USER}
                module={IDs.MOD_ETOOL_ADMIN}
                formLayout='flowV2'
                customClass={'Custom-ETA'}
                actions={['add', 'edit', 'delete']}
                addLabel={'Benutzer anlegen'}
                hiddenColumns={['password', 'password_reset_requested']}
                preFilterServer={{ registrierung: regi.tid }}
                preFilter={{ registrierung: regi.tid }}
                customFormConfig={customFormConfig}
                validateField={(key: string, value: any, data: any) => {
                    const formTid = data.values.tid;
                    if (formTid !== this.state.formTid) {
                        this.setState({ formTid, formUpdateCount: this.state.formUpdateCount + 1 });
                    }
                    return null;
                }}
                showColumnsHelp={true}
                callBeforeOnFormSave={this.callBeforeOnFormSave}
                onSaveDone={(entityName: string, values: any) => {
                    if (values.tid === 0) {
                        alert('Der/die von Ihnen angelegte Nutzer/in wurde per E-Mail informiert.');
                    }
                }}
            />
        </div> : null;
    }

    callBeforeOnFormSave(data: any, callback: () => void) {
        if (data.tid > 0) {
            callback();
            return;
        }
        if (data.mail) {
            this.apiService.call('checkMailExistence',
                { type: 'benutzerverwaltung', regiTid: data.registrierung, mail: data.mail, tid: data.tid, entity: IDs.ENT_MANDANTEN_USER, module: IDs.MOD_ETOOL_ADMIN },
                (res: string, suc: boolean) => {
                    // console.log(res, suc);
                    if (suc) {
                        if (res === '1') {
                            alert('E-Mail-Adresse existiert bereits.');
                        } else {
                            callback();
                        }
                    } else {
                        alert('Server Error');
                    }
                }
            );
        }
    }
}
